<template>
	<el-carousel v-if="data.length > 0" height="150px" style="margin-bottom: 30px; background: url('/assets/img/bd02.jpeg') no-repeat; background-size: 100% 100%; background-position: right top;" :interval="6000">
	    <el-carousel-item v-for="d in data" :key="d.userId">
	      <h3 v-if="d.isMe" style="text-align:left; margin-left:75px; margin-top: 30px;">{{ d.name }}, today is a great day! it's your birthday.</h3>
	      <h3 v-else style="text-align:left; margin-left:75px; margin-top: 10px;">Today is {{ d.name }}'s birthday, let's wish {{ d.sex }} happy birthday!<br>
	      <el-button size="small" class="btn1" @click="sendBlessing(d.userId)" style="text-align:center; margin-left:300px;">{{ $t('er.birthday.btn') }}</el-button></h3>
	    </el-carousel-item>
	</el-carousel>
</template>
<style scoped>
  .el-carousel__item h3 {
    color: #FFFFFF;
    font-size: 24px;
    font-weight: bold;
    opacity: 0.75;
    line-height: 60px;
    margin: 0px;
    text-align: center;
  }
  .btn1 {
  	background: rgba(255,255,255,0.01);
    border: 1px solid #ffffff;
    color: #ffffff;
  }
</style>
<script>
// @ is an alias to /src
import moment from 'moment'

export default {
  name: 'BirthdayCard',
  props: ['data'],
  data: function() {
	return {
	  data
	}
  },
  computed: {
    userId: function() {
      return localStorage.getItem('token')
    }
  },
  methods: {
    sendBlessing: function(uid) {
      let q = {
	      	'userId': this.userId
	      },
	      that = this
      this.$http.put(this.API_PREFIX + 'birthday/' + uid, q).then(function (response) {
		//do nothing
		that.$message({
	      message: that.$t('er.birthday.bless'),
	      type: 'success'
	    })
      }).catch(function (error) {
        that.$message({
	      message: that.$t('er.birthday.failed'),
	      type: 'error'
	    })
		console.log(error)
      })
    }
  },
  created: function() {
  }
}
</script>